<template>
  <div>
    <el-table
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      height="500px"
      style="width: 100%"
    >
      <el-table-column min-width="60" show-overflow-tooltip :label="'进度'" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.percentage==100">已完成</el-tag>
          <el-tag type="danger" v-else>未完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column min-width="60" show-overflow-tooltip :label="'资源格式'" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.documentType==1">文档</span>
          <span v-else-if="scope.row.documentType==3">图片</span>
          <span v-else-if="scope.row.documentType==4">音频</span>
          <span v-else>视频</span>
        </template>
      </el-table-column>
      <el-table-column min-width="150" show-overflow-tooltip :label="'名称'" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column min-width="60" show-overflow-tooltip :label="'积分'" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.score }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="'操作'" min-width="80" align="center">
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini" @click="newsVideo(scope.row)">立即学习</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import * as apiTrainPeople from '@/api/train/trainPeople';
import * as ApiPerson from '@/api/personcenter/index';

export default {
  props: ['trainId'],
  data() {
    return {
      tableKey: 1,
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //跳转到新页面进入视频的播放
    newsVideo(row) {
      if (row.objtype == 2) {
        sessionStorage.setItem('trainId', this.trainId);
        this.$router.push({
          path: '/studyclassDetail',
          query: {
            id: row.objId,
            trainId: this.trainId,
          },
        });
      } else if (row.objtype == 1) {
        sessionStorage.setItem('trainId', this.trainId);
        this.$router.push({
          path: '/sourceslist/videoLearn',
          query: {
            id: row.objId,
            trainId: this.trainId,
          },
        });
      }
    },
    getList() {
      let para = {
        trainId: this.trainId,
        userId: this.$store.state.User.ids,
      };
      // apiTrainPeople.getListCourse(para).then((res)=>{
      //     this.list=res.data
      // })

      ApiPerson.getCourseList(para).then((res) => {
        this.list = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>